import { BaseEndpoint, BaseSDK } from '@livefree/js-sdk';
import { TokenParser } from '@livefree/react-oauth2';

class MyEndpoint extends BaseEndpoint {
  constructor(config) {
    super('api/v1/my', config);
  }

  profile() {
    return super.get();
  }

  updateProfile(id, profile) {
    return super.update(id, profile);
  }

  applications() {
    const url = super.appendUrl('/applications');
    return super.httpGET({ url });
  }

  twoFactor() {
    const url = super.appendUrl('/two-factor');
    return super.httpGET({ url });
  }

  removeTwoFactor(twoFactorType, token) {
    const url = super.appendUrl('/two-factor');
    return super.httpDELETE({
      url,
      query: {
        twoFactorType,
        token,
      },
    });
  }

  setupTwoFactor(twoFactorType) {
    const url = super.appendUrl('/two-factor');
    return super.httpPOST({
      url,
      body: {
        twoFactorType,
      },
    });
  }

  validateTwoFactor(twoFactorType, token) {
    const url = super.appendUrl('/two-factor');
    return super.httpPUT({
      url,
      body: {
        twoFactorType,
        token,
      },
    });
  }
}

export class MyClient extends BaseSDK {
  #endpoint;
  constructor(baseUrl) {
    super(baseUrl);
    this.config.onRequireToken = () => Promise.resolve(TokenParser.accessToken);
    this.#endpoint = new MyEndpoint(this.config);
  }

  profile() {
    return this.#endpoint.profile();
  }

  updateProfile(id, profile) {
    return this.#endpoint.updateProfile(id, profile);
  }

  applications() {
    return this.#endpoint.applications();
  }

  twoFactor() {
    return this.#endpoint.twoFactor();
  }

  removeTwoFactor(twoFactorType, token) {
    return this.#endpoint.removeTwoFactor(twoFactorType, token);
  }

  setupTwoFactor(twoFactorType) {
    return this.#endpoint.setupTwoFactor(twoFactorType);
  }

  validateTwoFactor(twoFactorType, token) {
    return this.#endpoint.validateTwoFactor(twoFactorType, token);
  }

  clearCache() {
    return Promise.resolve();
  }
}
